<template>
  <div class="main">
    <div class="centered">
      <Header />
      <div class="main-content">
        <div class="main-selection">
          <MainSelectionMenu
            class="main-menu-list"
            v-bind:menuItems=mainMenuItems
            v-bind:selectedItem=selectedMenuItem
            v-on:selected-link="onMenuSelectedCollection"
          />
        </div>

        <!-- =*= VoD Data View *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= -->
        <div v-if="selectedMenuItem === 'VoD Data'" class="inner-main">
          <VodDataView
            class="data-view"
          />
        </div>

        <!-- =*= VoD Export View *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= -->
        <div v-if="selectedMenuItem === 'VoD Exports'" class="inner-main2">
          <div class="left-stack">
            <CollectionList
                    class="collection-list"
                    v-bind:collectionNames=collectionNames
                    v-bind:collectionTitles=collectionTitles
                    v-bind:selectedTitle=selectedCollectionTitle
                    v-on:selected-link="onSelectedCollection"
            />
            <Stats
                    class="vod-stats"
                    v-bind:collectionName=collectionName
                    v-on:on-selected-id="onSelectedId"
            />
          </div>

          <VideoList
                  class="video-list"
                  v-bind:collectionName=collectionName
                  v-bind:collectionTitle=selectedCollectionTitle
                  v-bind:externalSearchTerm=externalSearchTerm
                  v-bind:globalImageUrlCache=globalImageUrlCache
                  v-on:on-selected-video="onSelectedVideo" />
          <VideoDetails
                  class="details"
                  v-bind:globalImageUrlCache=globalImageUrlCache
                  v-bind:video=selectedVideo />
        </div>

        <!-- =*= VoD Filter View *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= -->
        <div v-if="selectedMenuItem === 'VoD Filters'" class="inner-main">
          <VodFilters />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Header from './Header.vue'
import VideoList from './VideoList.vue'
import CollectionList from './CollectionList.vue'
import MainSelectionMenu from './MainSelectionMenu.vue'
import Stats from './Stats.vue'
import VideoDetails from './VideoDetails'
import VodDataView from './VodDataView'
import VodFilters from './VodFilters'

export default {
  name: 'Dashboard',
  components: {
    Header,
    VideoList,
    CollectionList,
    MainSelectionMenu,
    Stats,
    VideoDetails,
    VodDataView,
    VodFilters
  },
  data () {
    return {
      collectionNames: [],
      collectionTitles: [],
      mainMenuItems: ['🔒 Catchup Data', '🔒 Video Archives', 'VoD Data', 'VoD Exports', 'VoD Filters', '🔒 EPG Data'],
      globalImageUrlCache: {},
      collectionName: null,
      collectionTitle: null,
      selectedMenuItem: 'VoD Exports',
      selectedCollectionTitle: '',
      selectedVideo: {
        target_data: {
          description: ''
        },
        source_data: {
          start: 0
        }
      },
      currentVideo: {},
      externalSearchTerm: ''
    }
  },
  mounted () {
    axios.get(`${this.$hostname}/getExports/`).then(response => {
      this.collectionNames = response.data.collectionNames
      let foundDates = {}
      this.collectionNames = this.collectionNames.sort()

      for (let i = 0; i < this.collectionNames.length; i += 1) {
        let collectionName = this.collectionNames[i].split('T')[0]
        if (Object.keys(foundDates).includes(collectionName)) {
          foundDates[collectionName] = foundDates[collectionName] + 1
        } else {
          foundDates[collectionName] = 1
        }
        collectionName = collectionName + ' Export #' + foundDates[collectionName]
        this.collectionTitles.push(collectionName)
      }

      this.collectionTitles = this.collectionTitles.reverse()
      this.collectionNames = this.collectionNames.reverse()

      this.collectionName = this.collectionNames[0]
      this.collectionTitle = this.collectionTitles[0]
      this.selectedCollectionTitle = this.collectionTitles[0]
    })
  },
  methods: {
    onSelectedCollection: function (collectionName) {
      this.selectedCollectionTitle = collectionName
      this.collectionName = collectionName

      for (let i = 0; i < this.collectionNames.length; i += 1) {
        if (this.collectionNames[i] === collectionName) {
          console.log('Click6.2: ' + this.collectionNames[i])
          this.collectionName = this.collectionNames[i]
        }
      }
    },
    onMenuSelectedCollection: function (menuItem) {
      console.log('here we are!', menuItem)
      this.collectionName = menuItem
      for (let i = 0; i < this.mainMenuItems.length; i += 1) {
        if (this.mainMenuItems[i] === menuItem) {
          this.collectionTitle = this.mainMenuItems[i]
        }
      }
      console.log('menuItem: ', menuItem)
      this.selectedMenuItem = menuItem
    },
    onSelectedVideo: function (selectedVideo) {
      console.log('Video selected: ' + selectedVideo.title)
      this.selectedVideo = selectedVideo
    },
    onSelectedId: function (selectedID) {
      console.log('ID selected: ' + selectedID)
      this.externalSearchTerm = selectedID
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    background-image: url('http://freenettv-dashboard.mixd.tv/squairy_dark.png');
    text-align: center;
    width: fit-content;
    min-width: 1200px;
  }
  .main-content {
    display: flex;
    min-width: 1200px;
  }
  .inner-main {
    display: flex;
    min-width: 1055px;
    width: calc(100vw - 145px);
  }
  .inner-main2 {
    display: flex;
    min-width: 1055px;
    width: calc(100vw - 164px);
  }
  .center-both {
    width: auto;
    margin: auto;
    font-size: xxx-large;
  }
  .left-stack {
    padding-left: 5px;
  }
  .main-selection {
    padding-left: 5px;
  }
  .centered {
    display: inline-block;
    background-color: rgba(255,255,255,0.2);
    height: 100vh;
    /* width: 100vw;
    overflow: scroll-x; */
  }
  .collection-list {
    height: calc((100vh - 72px)/2) !important;
    width: 250px;
    min-width: 150px;
    margin: 5px;
  }
  .main-menu-list{
    height: calc(100vh - 67px) !important;
  }
  .data-view{
    height: calc(100vh - 67px);
    width: calc(100vw - 140px)
  }
  .video-list {
    height: calc(100vh - 67px);
    width: 300px;
    min-width: 300px;
    margin: 5px;
    margin-left: 0px;
  }
  .vod-stats {
    height: calc((100vh - 72px)/2);
    width: 250px;
  }
  .details {
    width: calc(100vw - 770px);
    min-width: 300px;
    height: calc(100vh - 64px);
    margin: 5px;
    margin-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue